import React from 'react';
import ImageAndContent from 'components/consumer/ImageAndContent';

const ImageContentBlock = ({ blockConfig, isMobile = false }) => (
  <ImageAndContent
    config={{
      componentSelection: {
        imageUrl: blockConfig?.imageUrl,
      },
      textContentSection: {
        textColor: blockConfig?.textSection?.textColor,
        textOrientation: blockConfig?.textSection?.textOrientation,
        title: blockConfig?.title,
        body: blockConfig?.body,
      },
      buttonSection: blockConfig?.buttonSection,
    }}
    columnMode
    isMobile={isMobile}
  />
);

export default ImageContentBlock;
